<template>
	<input type="text" autocomplete="off" />
</template>
<script>
    export default {
        props: ['value', 'disabled'],

        mounted: function () {
            var self = this;

            $(self.$el)                    
                .datepicker({
                    uiLibrary: 'bootstrap4',
                    locale: 'es-es',
                    iconsLibrary: 'materialicons',
                    format: 'dd-mm-yyyy',
                    header: false,
                    footer: false,
                    modal: false,
                    value: this.value,
                    showOnFocus: true,
                    showRightIcon: false
                }) // init datepicker
                .trigger('change')                    
                .on('change', function () { // emit event on change.
                    self.$emit('input', this.value);
                })
        },

        watch: {
            value: function (value) {
                $(this.$el).val(value);
            },

            disabled: function(value){
                $(this.$el).find('button').attr('disabled', value);
                if (value) {
                    $(this.$el).find('a').hide();
                }else{
                    $(this.$el).find('a').show();
                }
            }
        },

        destroyed: function () {
            $(this.$el).datepicker('destroy');
        }
    }
</script>